export default __webpack_public_path__ + "static/media/AIDX Logo_v0.28a4d5a2.png";